/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuoteGroup } from "./QuoteGroup";
import {
  QuoteGroupFromJSON,
  QuoteGroupFromJSONTyped,
  QuoteGroupToJSON,
  QuoteGroupToJSONTyped,
} from "./QuoteGroup";
import type { ExperimentRun } from "./ExperimentRun";
import {
  ExperimentRunFromJSON,
  ExperimentRunFromJSONTyped,
  ExperimentRunToJSON,
  ExperimentRunToJSONTyped,
} from "./ExperimentRun";
import type { ProcessingState } from "./ProcessingState";
import {
  ProcessingStateFromJSON,
  ProcessingStateFromJSONTyped,
  ProcessingStateToJSON,
  ProcessingStateToJSONTyped,
} from "./ProcessingState";

/**
 *
 * @export
 * @interface ExperimentRunDetail
 */
export interface ExperimentRunDetail {
  /**
   *
   * @type {ExperimentRun}
   * @memberof ExperimentRunDetail
   */
  run: ExperimentRun;
  /**
   *
   * @type {ProcessingState}
   * @memberof ExperimentRunDetail
   */
  state: ProcessingState;
  /**
   *
   * @type {Array<QuoteGroup>}
   * @memberof ExperimentRunDetail
   */
  quoteGroups: Array<QuoteGroup>;
}

/**
 * Check if a given object implements the ExperimentRunDetail interface.
 */
export function instanceOfExperimentRunDetail(
  value: object,
): value is ExperimentRunDetail {
  if (!("run" in value) || value["run"] === undefined) return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  if (!("quoteGroups" in value) || value["quoteGroups"] === undefined)
    return false;
  return true;
}

export function ExperimentRunDetailFromJSON(json: any): ExperimentRunDetail {
  return ExperimentRunDetailFromJSONTyped(json, false);
}

export function ExperimentRunDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExperimentRunDetail {
  if (json == null) {
    return json;
  }
  return {
    run: ExperimentRunFromJSON(json["run"]),
    state: ProcessingStateFromJSON(json["state"]),
    quoteGroups: (json["quoteGroups"] as Array<any>).map(QuoteGroupFromJSON),
  };
}

export function ExperimentRunDetailToJSON(json: any): ExperimentRunDetail {
  return ExperimentRunDetailToJSONTyped(json, false);
}

export function ExperimentRunDetailToJSONTyped(
  value?: ExperimentRunDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    run: ExperimentRunToJSON(value["run"]),
    state: ProcessingStateToJSON(value["state"]),
    quoteGroups: (value["quoteGroups"] as Array<any>).map(QuoteGroupToJSON),
  };
}
